module.exports = __webpack_public_path__ + "assets/img/telegram.8edb23bf.png";